import React from "react";
import { prepareRichHtmlForDisplay } from "@/lib/sanitizeRichHtml";
import { cn } from "@/lib/utils";

/**
 * Bloco de HTML rico já sanitizado (cabeçalho/rodapé de proposta).
 */
export function RichHtmlFragment({ html, className }) {
  const safe = React.useMemo(() => prepareRichHtmlForDisplay(html), [html]);
  if (!safe) return null;
  return (
    <div
      className={cn(
        "prose prose-sm max-w-none text-slate-800 dark:prose-invert dark:text-slate-100 [&_a]:break-all",
        className
      )}
      dangerouslySetInnerHTML={{ __html: safe }}
    />
  );
}
